import { DEFAULT_DISTANCE_IN_MILES_FILTER } from "../constants";
import { type FiltersFormValues } from "./types";

export function calculateActiveFiltersCount(
  formValues: FiltersFormValues,
  datesLength: number
): number {
  const isDistanceFilterSet = formValues.distance !== DEFAULT_DISTANCE_IN_MILES_FILTER;
  const isShiftTimeSlotsFilterSet = formValues.shiftTimeSlots.length > 0;
  const isLicensesFilterSet = formValues.licenses.length > 0;
  const isDatesFilterSet = datesLength > 0;
  const isFavoriteWorkplacesFilterSet = formValues.favoriteWorkplacesOnly;
  const isIncludeWindowedOutShiftsFilterSet = formValues.includeWindowedOutShifts;
  const isIncludedStatesFilterSet = formValues.includedStates.length > 0;

  return (
    (isDistanceFilterSet ? 1 : 0) +
    (isShiftTimeSlotsFilterSet ? 1 : 0) +
    (isLicensesFilterSet ? 1 : 0) +
    (isDatesFilterSet ? 1 : 0) +
    (isFavoriteWorkplacesFilterSet ? 1 : 0) +
    (isIncludeWindowedOutShiftsFilterSet ? 1 : 0) +
    (isIncludedStatesFilterSet ? 1 : 0)
  );
}
